<mat-expansion-panel class="mat-elevation-z1" [expanded]="expanded">
  <mat-expansion-panel-header style="background-color: whitesmoke;">
    <mat-panel-title class="avenir-font text-nowrap">
      {{this.label}}
    </mat-panel-title>
    <mat-panel-description class="justify-content-end">
      <mat-icon [ngStyle]="{'color': includeItems.length > 0 ? '#9E81E4' : '#999'}">{{iconName}}</mat-icon>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="pt-4">
    <!-- Include Field -->
    <p class="avenir-font">
      <b>Include</b> people who work at the following companies
    </p>
    <mat-form-field class="w-100 mb-2" appearance="fill" subscriptSizing="dynamic" floatLabel="always">
      <mat-label class="avenir-font">{{ label }}</mat-label>
      <mat-chip-grid #includeChipList>
        <!-- Show '+ more' if more than 5 items -->
        <ng-container *ngIf="includeItems.length > 5">
          <mat-chip (click)="tagsShowMore(includeItems, 'include')"><small>+{{includeItems.length - 5}} more...</small></mat-chip>
        </ng-container>

        <!-- Display last 5 items -->
        <ng-container *ngFor="let item of includeItems.slice(-5)">
          <mat-chip [removable]="true" (removed)="remove(item, 'include')" class="custom-chip">
            <small *ngIf="this.searchField == 'website'" class="avenir-font">{{ item |truncate: 35}}</small>
            <small *ngIf="this.searchField != 'website'" class="avenir-font">{{ item | titlecase |truncate: 35}}</small>
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        </ng-container>

        <input #includeInput
          placeholder="{{ placeholder }}"
          [formControl]="includeInputControl"
          [matAutocomplete]="auto"
          [matChipInputFor]="includeChipList"
          [matChipInputAddOnBlur]="addOnBlur">
        <mat-spinner color="primary" diameter="20" *ngIf="loading"></mat-spinner>
      </mat-chip-grid>

      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event, 'include'); includeInput.value = ''">
        <mat-option *ngFor="let item of includeFilteredItems | async" [value]="item" class="mt-2 mb-2">
          <div class="d-flex align-items-center">
            <clearbit-logo *ngIf="this.searchField == 'companyName'" [domain]="item?.website" [height]="25" [width]="25"></clearbit-logo>
            <clearbit-logo *ngIf="this.searchField == 'website'" [domain]="item?.name" [height]="25" [width]="25"></clearbit-logo>
            <small *ngIf="this.searchField == 'website'" class="avenir-font">{{ item.name }}</small>
            <small *ngIf="this.searchField != 'website'" class="avenir-font">{{ item.name | titlecase }}</small>
          </div>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <p class="avenir-font">
      <b>Exclude</b> people who work at the following companies
    </p>
    <!-- Exclude Field -->
    <mat-form-field class="w-100" appearance="fill" subscriptSizing="dynamic" floatLabel="always">
      <mat-label class="avenir-font">{{ label }}</mat-label>
      <mat-chip-grid #excludeChipList>
        <!-- Show '+ more' if more than 5 items -->
        <ng-container *ngIf="excludeItems.length > 5">
          <mat-chip (click)="tagsShowMore(excludeItems, 'exclude')"><small>+{{excludeItems.length - 5}} more...</small></mat-chip>
        </ng-container>

        <!-- Display last 5 items -->
        <ng-container *ngFor="let item of excludeItems.slice(-5)">
          <mat-chip [removable]="true" (removed)="remove(item, 'exclude')"  class="custom-chip">
            <small *ngIf="this.searchField == 'website'" class="avenir-font">{{ item |truncate: 35 }}</small>
            <small *ngIf="this.searchField != 'website'" class="avenir-font">{{ item | titlecase |truncate: 35 }}</small>
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        </ng-container>

        <input #excludeInput
          placeholder="{{ placeholder }}"
          [formControl]="excludeInputControl"
          [matAutocomplete]="auto1"
          [matChipInputFor]="excludeChipList"
          [matChipInputAddOnBlur]="addOnBlur">
        <mat-spinner color="primary" diameter="20" *ngIf="loading"></mat-spinner>
      </mat-chip-grid>

      <mat-autocomplete #auto1="matAutocomplete" (optionSelected)="selected($event, 'exclude'); includeInput.value = ''">
        <mat-option *ngFor="let item of excludeFilteredItems | async" [value]="item" class="mt-2 mb-2">
          <div class="d-flex align-items-center">
            <clearbit-logo *ngIf="this.searchField == 'companyName'" [domain]="item?.website" [height]="25" [width]="25"></clearbit-logo>
            <clearbit-logo *ngIf="this.searchField == 'website'" [domain]="item?.name" [height]="25" [width]="25"></clearbit-logo>
            <small *ngIf="this.searchField == 'website'" class="avenir-font">{{ item.name }}</small>
            <small *ngIf="this.searchField != 'website'" class="avenir-font">{{ item.name | titlecase }}</small>
          </div>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
</mat-expansion-panel>
